import React, { useEffect, useState } from "react";
import {
  backEndTag,
  dbTag,
  frontEndTag,
  langTag,
  miscTag,
  mobileTag,
  skillSet,
} from "./constants";
import "./Skills.css";

const SkillsTab = () => {
  const [search, setSearch] = useState(null);
  const [filteredSkills, setFilteredSkills] = useState(skillSet);
  const [chosenTag, setChosenTag] = useState(null);

  useEffect(() => {
    if (search) setChosenTag(null);

    const filt = search
      ? skillSet.filter((el) =>
          el.name.toLowerCase().includes(search.toLowerCase())
        )
      : skillSet;

    setFilteredSkills(filt);
  }, [search]);

  useEffect(() => {
    if (chosenTag) {
      const filt = skillSet.filter((el) => el.tags.includes(chosenTag));

      setFilteredSkills(filt);
    } else {
      setFilteredSkills(skillSet);
    }
  }, [chosenTag]);

  return (
    <div className="skillsContainer">
      <div className="skillsBox">
        <div className="skillsColumn" id="front">
          <div className="subSkillContainer">
            {filteredSkills.map((skill, index) => (
              <div
                className="subSkill"
                key={index}
                style={{
                  backgroundImage: `url(${skill.img})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>
            ))}
          </div>
          <input
            type="text"
            className="inputSkills"
            placeholder="React, Nest, PostgreSQL ..."
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="filter-menu">
            <button
              className="filter-button"
              name="AllTag"
              onClick={() => setChosenTag(null)}
            >
              All
            </button>

            {[frontEndTag, backEndTag, mobileTag, langTag, dbTag, miscTag].map(
              (buttonElTag, index) => (
                <button
                  key={index}
                  className={`filter-button ${
                    chosenTag === buttonElTag && "current-button"
                  }`}
                  name={buttonElTag}
                  onClick={() => setChosenTag(buttonElTag)}
                >
                  {buttonElTag}
                </button>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillsTab;
